import { useNotificationStore } from '@/store/notification.js'

export default {
  install(app) {
    const notification = {
      confirm(textOrOptions, onApply, payload, type, textApply, textCancel, title = '',
        maxWidth = null, hasIcon = true, isTextCenter = true) {
        const store = useNotificationStore()

        let options

        if (typeof textOrOptions === 'object' && textOrOptions !== null) {
          const {
            text,
            onApply,
            payload,
            type,
            textApply,
            textCancel,
            title = '',
            maxWidth = null,
            hasIcon = true,
            isTextCenter = true
          } = textOrOptions

          options = {
            title,
            text,
            onApply,
            payload,
            type,
            textApply,
            textCancel,
            maxWidth,
            hasIcon,
            isTextCenter
          }
        } else {
          options = {
            title,
            text: textOrOptions,
            onApply,
            payload,
            type,
            textApply,
            textCancel,
            maxWidth,
            hasIcon,
            isTextCenter
          }
        }

        store.confirm(options)
      },
      alert(text, textOk, type, link, textLink) {
        const store = useNotificationStore()
        store.alert({
          text,
          textOk,
          type,
          link,
          textLink
        })
      }
    }

    app.config.globalProperties.$notification = notification
  }
}
